// Colores para la prioridad
export const getPriorityClasses = (prioridad) => {
    switch (prioridad) {
      case 'Alta':
        return 'bg-teal-600 text-white px-2 py-1';
      case 'Media':
        return 'bg-purple-500 text-white px-2 py-1';
      case 'Baja':
        return 'bg-blue-500 text-white px-2 py-1';
      default:
        return 'bg-gray-200 text-black px-2 py-1';
    }
  };

  export const getStatusClasses = (estado) => {
    switch (estado) {
        case 'Agotado':
            return 'bg-red-500 text-white font-bold'; 
        case 'Por Agotarse':
            return 'bg-yellow-300 text-black-500 font-bold';
        case 'En Camino':
            return 'bg-purple-500 text-white font-bold';
        case 'Standby':
            return 'bg-gray-600 text-white font-bold'; 
        case 'No Despachado':
            return 'bg-orange-500 text-white font-bold';
        default:
            return 'bg-green-500 text-white font-bold';
    }
};
export const getStatStyle = (statKey) => {
  switch (statKey) {
      case 'Agotado':
          return 'bg-red-500 text-white';
      case 'Por Agotarse':
          return 'bg-yellow-300 text-black';
      case 'En Camino':
          return 'bg-purple-500 text-white';
      case 'Standby':
          return 'bg-gray-600 text-white';
      case 'No Despachado':
          return 'bg-orange-500 text-white';
      case 'Alta':
          return 'bg-teal-600 text-white';
      case 'Media':
          return 'bg-purple-500 text-white';
      case 'Baja':
          return 'bg-blue-500 text-white';
      default:
          return 'bg-green-500 text-white';
  }
};

/** Badges de rotación de inventario (sistema interno POS) */
export const ROTACION_BADGES = {
    liquidacion: {
        label: 'Véndalo y no lo vuelva a pedir',
        className: 'bg-red-700 text-white font-bold',
        tooltip: 'Sin ventas en mucho tiempo. Se desactivará al agotarse.'
    },
    sin_ventas: {
        label: 'Nuevo sin ventas',
        className: 'bg-yellow-400 text-black font-semibold',
        tooltip: 'Producto reciente que aún no registra ventas.'
    },
    lento: {
        label: 'Sin ventas hace +90d',
        className: 'bg-orange-500 text-white font-semibold',
        tooltip: 'Tuvo ventas pero lleva más de 90 días sin moverse.'
    },
    alta_rotacion: {
        label: 'Alta rotación',
        className: 'bg-emerald-600 text-white font-semibold',
        tooltip: 'Varias ventas en los últimos 30 días.'
    }
};

export const getRotacionBadge = (estadoRotacion) => {
    return ROTACION_BADGES[estadoRotacion] || null;
};

export const getConsolidatedStatusClasses = (estado) => {
    switch (estado) {
        case 'Borrador':
            return 'bg-black-500 text-white py-2 px-3 rounded-full';
        case 'Pendiente':
            return 'bg-orange-500 text-white py-2 px-3 rounded-full';
        case 'Aprobado':
            return 'bg-purple-500 text-white py-2 px-3 rounded-full';
        case 'Completado':
            return 'bg-green-500 text-white py-2 px-3 rounded-full';
        default:
            return 'bg-gray-200 text-black py-2 px-3 rounded-full';
    }
};